import React from 'react';
import { makeStyles } from '@material-ui/core';
import config from '@/configs/config';

const useStyle = makeStyles((theme) => ({
  root: {
    alignItems: 'center',
    background: 'transparent',
    border: 0,
    display: 'flex',
    flexDirection: 'column',
    outline: 0,
    position: 'relative',
  },
  flag: {
    background: theme.palette.primary.main,
    borderRadius: 8,
    fontSize: 10,
    fontWeight: 'bold',
    left: 8,
    padding: theme.spacing(0, 1),
    position: 'absolute',
    top: 0,
    zIndex: 1,
  },
  coverContainer: {
    position: 'relative',
  },
  coverImageContainer: {
    borderRadius: '50%',
    display: 'flex',
    height: 140,
    overflow: 'hidden',
    width: 140,
    alignItems: 'center',
    justifyContent: 'center',
  },
  coverLabel: {
    background: theme.palette.preOrder.main,
    borderRadius: 6,
    bottom: 0,
    color: '#ffffff',
    fontSize: 12,
    fontWeight: 'bold',
    left: '50%',
    lineHeight: 1,
    padding: theme.spacing(0.5, 1.5),
    position: 'absolute',
    transform: 'translateX(-50%)',
    whiteSpace: 'nowrap',
  },
  infoContainer: {
    alignItems: 'center',
    color: 'black',
    display: 'flex',
    flexDirection: 'column',
    marginTop: theme.spacing(1),
  },
  provider: {
    fontSize: 12,
  },
  product: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  price: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: 'Roboto',
  },
  onSale: {
    color: theme.palette.price.onSale,
    marginLeft: theme.spacing(1),
    fontFamily: 'Roboto',
  },
}));

export default ({ data, onClick: propsOnClick, index }) => {
  const classes = useStyle();
  const {
    name,
    price,
    productNumber,
    provider,
    sellPrice,
  } = data;

  const onClick = () => {
    propsOnClick(data);
  };

  return (
    <button type="button" className={classes.root} onClick={onClick}>
      <div className={classes.flag}>{`人氣 NO. ${index + 1}`}</div>
      <div className={classes.coverContainer}>
        <div className={classes.coverImageContainer}>
          <img src={`${config.RESOURCE_URI}ProductImages/${productNumber}.jpg`} alt="" width="100%" />
        </div>
        <div className={classes.coverLabel}>我要預訂</div>
      </div>
      <div className={classes.infoContainer}>
        <div className={classes.provider}>{provider}</div>
        <div className={classes.product}>{name}</div>
        <div className={classes.price}>
          {
            price > sellPrice
              ? (
                <>
                  <span style={{ fontSize: 12, textDecoration: 'line-through', fontFamily: 'Roboto' }}>{`$${price}`}</span>
                  <span className={classes.onSale}>{`$${sellPrice}`}</span>
                </>
              ) : (
                `$${price}`
              )
          }
        </div>
      </div>
    </button>
  );
};
